import { customAlphabet } from 'nanoid';
import { isBrowser } from './platform';
const nanoid = customAlphabet('1234567890abcdef', 10);
const language = isBrowser ? navigator && navigator.language : '';
const notInClient = language.includes('zh')
    ? '不在客户端环境内'
    : 'Not In Client';
const timeoutInClient = language.includes('zh')
    ? '客户端通信超时'
    : 'client call timeout';
const callbacks = ({
    _id: nanoid(),
    _getId() {
        return nanoid();
    },
});
/**
 * [2022-05-31]
 * 注：使用 StringReadonlyDictionary 来代替 as const 让属性只读属性
 */
const jsBridgeMap = {
    ios: 'WebViewJavascriptBridge',
    android: 'XLJSWebViewBridge',
    account: 'XLAccountJsBridge',
    mac: 'WebViewJavascriptBridge',
    pc: 'native',
    xbase: 'XBaseObject',
};
const handleMap = {
    ios: 'callHandler',
    android: 'sendMessage',
    account: 'callFunction',
    mac: 'callHandler',
    pc: 'CallNativeFunction',
    xbase: 'call',
};
export function sendMessage(nativeCallParams, config) {
    const platform = nativeCallParams['platform'];
    const params = 'params' in nativeCallParams ? nativeCallParams['params'] : null;
    const method = handleMap[platform];
    const jsBridge = jsBridgeMap[platform];
    if (!window[jsBridge]) {
        // eslint-disable-next-line
        return Promise.reject(notInClient);
    }
    let { isCallBack = false, callbackTimeout = 5000, noCallback = false, } = Object.assign({}, config);
    // ios, mac 和 pc 默认支持回调函数
    if (['ios', 'mac', 'pc'].includes(platform))
        isCallBack = true;
    const clientPromise = new Promise((resolve, _) => {
        if (isCallBack) {
            let paramsList = [nativeCallParams.name];
            if (params) {
                paramsList.push(params);
            }
            else {
                paramsList.push({});
            }
            paramsList.push((...args) => {
                resolve(args);
            });
            window[jsBridge][method](...paramsList);
        }
        else {
            let preparedParamList = [nativeCallParams.name];
            if (platform === 'xbase') {
                preparedParamList = [
                    JSON.stringify(nativeCallParams.context),
                    nativeCallParams.module,
                    nativeCallParams.name,
                ];
            }
            const callbackKey = '_callback_' + callbacks._getId() + '_' + nativeCallParams.name;
            const callbackName = 'G2_callbacks' + callbackKey;
            window[callbackName] = function (args) {
                callbacks[callbackKey] = null;
                window[callbackName] = null;
                if (['[object Object]', '[object Array]'].includes(Object.prototype.toString.call(args))) {
                    resolve(args);
                }
                else {
                    try {
                        const data = JSON.parse(args);
                        resolve(data);
                    }
                    catch (err) {
                        resolve(args);
                    }
                }
            };
            if (params) {
                preparedParamList.push(JSON.stringify(params));
            }
            else {
                preparedParamList.push(JSON.stringify({}));
            }
            const gCallbackName = 'window.' + callbackName;
            preparedParamList.push(gCallbackName);
            window[jsBridge][method](...preparedParamList);
        }
    });
    // TODO (和兴广确认): noCallback 是不是可以前置判断？？
    // 我看到很多代码都直接设置为 true，那么如果是 true，那 callbackTimeout 的判断就没有意义
    const noTimeout = callbackTimeout === 0 || noCallback;
    return Promise.race([
        clientPromise,
        !noTimeout &&
            promiseTimeOut(callbackTimeout, `${nativeCallParams.name}-${timeoutInClient}`),
    ]);
}
function promiseTimeOut(time, reason = '') {
    return new Promise((_resolve, reject) => {
        setTimeout(() => {
            reject(reason);
        }, time);
    });
}
const handleEventOnMap = {
    mac: 'addEventListener',
    pc: 'AttachNativeEvent',
};
const handleEventOffMap = {
    mac: 'removeEventListener',
    pc: 'DetachNativeEvent',
};
export function onMessage(nativeCallEvents) {
    const platform = nativeCallEvents['platform'];
    const jsBridge = jsBridgeMap[platform];
    const method = handleEventOnMap[platform];
    if (!window[jsBridge]) {
        // eslint-disable-next-line
        return Promise.reject(notInClient);
    }
    const args = [nativeCallEvents.name, nativeCallEvents.callback];
    return window[jsBridge][method](...args);
}
export function offMessage(nativeCallEventsOff) {
    const platform = nativeCallEventsOff['platform'];
    const jsBridge = jsBridgeMap[platform];
    const method = handleEventOffMap[platform];
    if (!window[jsBridge]) {
        // eslint-disable-next-line
        return Promise.reject(notInClient);
    }
    const args = [nativeCallEventsOff.name, nativeCallEventsOff.eventId];
    return window[jsBridge][method](...args);
}
const handleEventCheckMap = {
    mac: 'checkFunction',
    ios: 'checkFunction',
    pc: 'CheckNativeFunction',
};
export function checkMessage(nativeCallEventsCheck) {
    const platform = nativeCallEventsCheck['platform'];
    const jsBridge = jsBridgeMap[platform];
    const method = handleEventCheckMap[platform];
    return new Promise((resolve, reject) => {
        if (!window[jsBridge]) {
            // eslint-disable-next-line
            reject(notInClient);
        }
        const paramsList = [nativeCallEventsCheck.name];
        paramsList.push((args) => {
            resolve(args);
        });
        window[jsBridge][method](...paramsList);
    });
}
//# sourceMappingURL=data:application/json;base64,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